<script>
  import { layoutMethods, cifMethods } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  /**
   * Logs
   */
  export default {
    page: {
      title: "Logs"
    },
    components: {
      flatPickr
    },
    computed: {
    },
    data() {
      return {
        title: "Logs",
        searchValue: {
          changeType: null,
          dateRange: null,
          sort: 'id',
          orderDesc: true,
          page: 1,
          rows: 10
        },
        changeTypeOptions: [
          { text: "Search All", value: null },
          { text: "Mobile", value: "mobile" },
          { text: "Manual", value: "manual" }
        ],
        rangeOptions: {
          mode: "range",
        },
        fields: [
          {key: "referrenceNo", sortable: true, label: 'Reference Number'},
          {key: "changeType", sortable: true, label: 'Change Type', class:"text-capitalize"},
          {key: "modifiedBy", sortable: true, label: 'Modified By'},
          {key: "modifiedDate", sortable: true, label: 'Modified Date & Time'},
          {key: "changes", sortable: false, label: 'Changes'}
        ] ,
        tableData: [],
        tableTotal: 0,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      }
    },
    methods: {
      ...layoutMethods,
      ...cifMethods,
      async onSearch(state){
          this.tableData = [];
        // console.log(">>> status", status,JSON.stringify(this.searchValue));
          if(state == 'reset'){
            this.searchValue.page = 1;
          }

          await this.actionCIF({
              action: "cif-change-logs",
              body: this.searchValue
          }).then((res)=>{//
              this.tableData = res.message.rows
              this.tableTotal= res.message.pageInfo.total
              // console.log("res",JSON.stringify(res));
          }).catch((err)=>{
              console.log("err", err);
              this.tableData = []
              this.tableTotal= 0
          })
      },
      tableSort(ctx){//context
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        // console.log(">> sorting...",ctx);
        this.onSearch('reset');
      },
    },
    async mounted(){
      // alert("hey logs");
      await this.onSearch();
    }
  }
</script>



<template>
  <div><!-- outer div-->
    <h5 class="card-title text-dark">
        <span class="fw-normal ms-lg-2"> {{ tableTotal }} </span> Record(s)
    </h5>

    <div class="d-flex flex-wrap my-2">
      <div class="me-2 ta-right">
        <b-form-group label-for="change-type" description="Filter by Changes">
          <b-form-select class="form-select rounded-0 rounded-start shadow-none" style="width:160px"
            id="change-type"
            v-model="searchValue.changeType"
            :options="changeTypeOptions"
          ></b-form-select>
        </b-form-group>
      </div>
      <div class="me-2 ta-right">
        <b-form-group description="Filter by Date Range">
          <flat-pickr
            v-model="searchValue.dateRange"
            :config="rangeOptions"
            placeholder="Select a Date Range"
            class="form-control"
            style="width: fit-content"
          ></flat-pickr>
        </b-form-group>
      </div>
      <div class="me-2">
        <a class="btn btn-primary h-fit" @click="onSearch('reset')">
          <i class='bx bx-search bx-fw'></i>Search
        </a>
      </div>
    </div><!--end of the search values-->

    <div><!--table-->
      <!-- {{ searchValue }} -->
      <div class="table-responsive">
        <div class="table align-middle table-nowrap">
          <b-table
            :items="tableData"
            :fields="fields"
            responsive="sm"
            :current-page="searchValue.page"
            class="table-check"
            @sort-changed="tableSort" 
          >
            <template #cell(modifiedDate)="data">
              {{ data.item.modifiedDate | formatDate }}
            </template>
          </b-table>
        </div>
      </div>
      
      <div class="row g-0 text-center" v-if="tableTotal == 0">
        <span>No data to display.</span>
      </div>

      <div class="row" v-if="tableTotal != 0 && tableTotal > searchValue.rows">
        <div class="col">
          <div class="form-group row pull-left">
            <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
            <div class="col-sm-6">
              <b-form-group label-for="display-record">
                <b-form-select class="form-select shadow-none w-fit"
                  id="display-record"
                  v-model="searchValue.rows"
                  :options="pageOptions"
                  @change="onSearch('reset')"
                ></b-form-select>
              </b-form-group>
            </div>
          </div>
          <div
            class="
              dataTables_paginate
              paging_simple_numbers
              float-end
            "
          >
            <b-pagination
              v-if="tableTotal != 0 && tableTotal > searchValue.rows"
              class="pagination-rounded"
              v-model="searchValue.page"
              :total-rows="tableTotal"
              @input="onSearch()"
              :per-page="searchValue.rows"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div><!--end of tbl-->
  </div> <!-- end of outer div-->
</template>



<style>
</style>